// extracted by mini-css-extract-plugin
export default {"productDetails_characteristics":"productsDetailCharacteristics_productDetails_characteristics__BqT1D","characteristic":"productsDetailCharacteristics_characteristic__82xVR"};